<h3 align="center">DE CIFRIS TRENDS IN MODERN CRYPTOGRAPHY</h3>
<p>
	La ricca attività di ricerca svolta all’interno della comunità
	crittografica Italiana, sia nel campo accademico, sia nel mondo del lavoro e
	dell'impresa, in questa occasione si completa di un'intensa serie di lezioni ed
	eventi seminariali. Il complesso di
	interventi, coordinato dall’università di Trento, coinvolge i docenti di ben
	20 Università.
	Questo corso fornisce un'introduzione ad alcuni aspetti recenti della
	crittografia, come la crittografia post-quantum e la crittografia su cloud.
</p>
<img style="width: 30vw" src="../../../assets/attivita/deCifrisTrends/Locandina.png" class="rounded mx-auto d-block"
	alt="...">
<br>
<p>
	Il corso è utile a chiunque abbia familiarità con la crittografia standard e il
	suo background matematico, tra cui: dottorandi, laureati , professionisti che
	lavorano per aziende o settore pubblico.
	In particolare il corso è adatto a studenti di laurea magistrale con
	speciale interesse per la crittografia.
</p>
<hr id="info">
<div class="row">
	<div class="col-md-12">
		<h3>INFORMAZIONI GENERALI</h3>
		<h5>Organizzatori</h5>
		<p>Massimiliano Sala e Marco Calderini.</p>
		<h5>Docenti</h5>
		<p>Marco Baldi (UNIVPM Ancona), Stefano Barbero (POLITO Torino), Andrea Basso (University of Birmingham), Laura
			Capuano (UNIRM3 Roma), Michela Ceria (POLIBA Bari), Roberto Civino (UNIVAQ L'Aquila), Mario Di Raimondo
			(UNICT Catania), Annamaria Iezzi (UNINA Napoli),
			Roberto La Scala (UNIBA Bari), Massimo Lauria (UNIRM Roma), Riccardo Longo (UNITN Trento), Carla Mascia
			(UNITN Trento), Nadir Murru (UNITN Trento), Marco Pedicini (UNIRM3 Roma), Giordano Santilli (UNITN Trento),
			Lea Terracini (UNITO Torino), Marco Timpanella (UNIPG Perugia), Irene Villa (UNITN Trento), Andrea Visconti
			(UNIMI Milano).</p>
		<h5>Lingua</h5>
		<p>Inglese.</p>
		<h5>Modalità di Fruizione del Corso</h5>
		<p>Lezioni tramite Zoom.</p>
		<h5>Lezioni</h5>
		<p>20 lezioni da 25 minuti l'una dal 02/05/2022 al 27/05/2022, inoltre
			alcuni seminari saranno disponibili ai partecipanti del corso. </p>
		<h5>Fees</h5>
		<p>
			Il corso può essere frequentato da chiunque si iscriva e ne paghi la quota,
			fino ad un massimo di 300 (trecento) iscritti. La tariffa standard è di 200 euro,
			tuttavia:
		</p>
		<ul>
			<li>Gli studenti immatricolati (compresi i dottorandi) delle
				seguenti università non pagano alcuna quota per la frequenza al corso
				(analogamente per il personale, post-doc, ecc.): <br>
				Università Politecnica delle Marche,
				Università degli Studi dell'Aquila,
				Politecnico di Bari,
				Università degli Studi di Bari,
				Università degli Studi della Campania,
				Università di Catania,
				Università di Genova,
				Università di Messina,
				Politecnico di Milano,
				Università degli Studi di Milano,
				Università degli Studi di Napoli,
				Università degli Studi di Perugia,
				Università degli Studi di Roma, Università degli Studi di Roma Tor Vergata,
				Università Roma Tre, Università degli Studi di Salerno,
				Politecnico di Torino, Università di Torino, Università degli
				Studi di Trento, Università degli Studi di Verona.
			</li>
			<li>Gli studenti di qualsiasi altra università (compresi dottorandi e
				studenti stranieri) pagano 50 euro.</li>
			<li>I dipendenti delle aziende all'interno dell'Advisory Board De
				Cifris beneficiano di una tariffa ridotta di 100 euro per addetto.</li>
		</ul>
		<h5>Ulteriori Informazioni</h5>
		<p>Per ogni informazione relativa all'iscrizione
			contattare la dott.ssa Chiara Brollo (chiara.brollo&#64;unitn.it).
			Per informazioni sulla parte scientifica,
			contattare il dott. Marco Calderini (marco.calderini&#64;unitn.it).
		</p>
		<h5>Modalità di Pagamento</h5>
		<p>Per iscriversi al corso e pagare la relativa quota facciamo riferimento al seguente
			<a href="https://webapps.unitn.it/form/it/Web/GoHome/cdf/DCTMC2022" target="blank">form</a>.
		</p>
	</div>
</div>
<hr id="programma">
<div class="row">
	<div class="col-md-12">
		<h3>PROGRAMMA DEL CORSO</h3>
		<table class="table table-striped">
			<thead>
				<tr>
					<th scope="col">Data</th>
					<th>Titolo</th>
					<th scope="col">Argomenti</th>
					<th scope="col">Docenti</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">
						2 Maggio <br>
						ore 15:00
					</th>
					<td>
						Course introduction <br>
						(<a href="https://www.youtube.com/watch?v=MEluBT1sr7Y&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=1"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Sketch of the course</li>
							<li>Introduction to post-quantum cryptography</li>
							<li>Intro to cloud encryption</li>
							<li>Intro to complexity theory</li>
						</ul>
					</td>
					<td>
						Massimiliano Sala<br>
						Marco Calderini <br>
						(UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						3 Maggio <br>
						ore 15:00
					</th>
					<td>
						Lattices mod 1 <br>
						(<a href="https://www.youtube.com/watch?v=ExWp6fxxZ9A&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=2"
							target="_blank">Video</a>)
					</td>
					<td>
						Linear algebra over lattices:
						<ul>
							<li>Basis of a lattice</li>
							<li>Dimension of a lattice</li>
							<li>Length and distance</li>
						</ul>
					</td>
					<td>Lea Terracini <br> (UNITO)</td>
				</tr>
				<tr>
					<th scope="row">
						4 Maggio <br>
						ore 17:00
					</th>
					<td>
						Lattices mod 2 <br>
						(<a href="https://www.youtube.com/watch?v=xghX--ZhTrk&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=3"
							target="_blank">Video</a>)
					</td>
					<td>
						Determinant:
						<ul>
							<li>Fundamental Domain</li>
							<li>Determinant</li>
							<li>Hadamard’s inequality</li>
							<li>Hermite’s Theorem</li>
						</ul>
					</td>
					<td>Giordano Santilli <br> (UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						5 Maggio <br>
						ore 15:00</th>
					<td>
						Problems over lattices <br>
						(<a href="https://www.youtube.com/watch?v=xIzJlBLqhQY&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=4"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>SVP and CVP</li>
							<li>Appr-SVP</li>
							<li>Gaussian heuristic</li>
							<li>LLL</li>
							<li>Babai’s Closest Vertex Algorithm</li>
						</ul>
					</td>
					<td>Stefano Barbero <br> (POLITO)</td>
				</tr>
				<tr>
					<th scope="row">
						6 Maggio <br>
						ore 16:00</th>
					<td>
						Complexity of the <br> problems for lattices <br>
						(<a href="https://www.youtube.com/watch?v=qap3oV3EZ3U&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=5"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Complexity of SVP</li>
							<li>Complexity of CVP</li>
							<li>Complexity of their approximate versions</li>
						</ul>
					</td>
					<td>Massimo Lauria <br> (Roma Sapienza)</td>
				</tr>
				<tr>
					<th scope="row">
						9 Maggio <br>
						ore 18:00 </th>
					<td>
						NTRU encryption <br>
						(<a href="https://www.youtube.com/watch?v=jxqeIRtLgHI&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=6"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>The encryption algorithm (classical) NTRU</li>
							<li>The NTRU-HRSS-KEM (NIST submission round 2)</li>
						</ul>
					</td>
					<td>Nadir Murru <br> (UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						10 Maggio <br>
						ore 15:00 </th>
					<td>
						Attacks to NTRU <br>
						(<a href="https://www.youtube.com/watch?v=cF3IXLyzQ9A&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=7"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Coppersmith and Shamir</li>
							<li>Other attacks</li>
						</ul>
					</td>
					<td>Andrea Visconti <br> (UNIMI)</td>
				</tr>
				<tr>
					<th scope="row">
						11 Maggio <br>
						ore 15:00 </th>
					<td>
						LWE <br>
						(<a href="https://www.youtube.com/watch?v=JaX5MoeKAXU&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=8"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>LWE on lattices</li>
							<li>LWE on polynomial rings</li>
						</ul>
					</td>
					<td>Roberto Civino <br> (UNIVAQ)</td>
				</tr>
				<tr>
					<th scope="row">
						12 Maggio <br>
						ore 17:00 </th>
					<td>
						Crystals & Saber <br>
						(<a href="https://www.youtube.com/watch?v=8abaR_2bWfQ&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=9"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>The cryptosystems Crystals, Kyber and Dilithium </li>
							<li>The cryptosystem Saber</li>
						</ul>
					</td>
					<td>Andrea Basso <br> (University of Birmingham)</td>
				</tr>
				<tr>
					<th scope="row">
						13 Maggio <br>
						ore 15:00 </th>
					<td>Problems on codes <br>
						(<a href="https://www.youtube.com/watch?v=o1-ftvM8rFo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=10"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Linear codes</li>
							<li>The MLD problem</li>
							<li>The equivalence problem</li>
						</ul>
					</td>
					<td>Marco Timpanella <br> (UNIPG)</td>
				</tr>
				<tr>
					<th scope="row">
						16 Maggio <br>
						ore 15:00 </th>
					<td>
						Code-based cryptography <br>
						(<a href="https://www.youtube.com/watch?v=YLgE13JpQWM&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=11"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>McEliece</li>
							<li>Niederreiter</li>
							<li>LEDAcrypt</li>
						</ul>
					</td>
					<td>Marco Baldi <br> (UNIVPM)</td>
				</tr>
				<tr>
					<th scope="row">
						17 Maggio <br>
						ore 15:00 </th>
					<td>
						Foundations of multivariate crypto <br>
						(<a href="https://www.youtube.com/watch?v=HpL0PqkFn7I&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=12"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Definition of the MQ problem</li>
							<li>Methods to solve multivariate polynomial systems</li>
							<li>Special methods for the finite field case</li>
						</ul>
					</td>
					<td>Michela Ceria <br> (POLIBA)</td>
				</tr>
				<tr>
					<th scope="row">
						18 Maggio <br>
						ore 16:00 </th>
					<td>
						Rainbow digital signature <br>
						(<a href="https://www.youtube.com/watch?v=C8LP7mzpwgo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=13"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>The digital signature scheme Rainbow</li>
							<li>Security of Rainbow</li>
						</ul>
					</td>
					<td>Roberto La Scala <br> (UNIBA)</td>
				</tr>
				<tr>
					<th scope="row">
						19 Maggio <br>
						ore 17:00 </th>
					<td>
						ABE-paring <br>
						(<a href="https://www.youtube.com/watch?v=eaTZZn6AnWo&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=14"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Formal properties of pairings</li>
							<li>Tate pairing</li>
							<li>Weil pairing</li>
						</ul>
					</td>
					<td>Laura Capuano <br> (ROMA3)</td>
				</tr>
				<tr>
					<th scope="row">
						20 Maggio <br>
						ore 15:00 </th>
					<td>
						ABE-IBE <br>
						(<a href="https://www.youtube.com/watch?v=3vPiWQO7YsE&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=15"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Boneh Franklin scheme</li>
							<li>Fuzzy IBE</li>
						</ul>
					</td>
					<td>Annamaria Iezzi <br> (UNINA)</td>
				</tr>
				<tr>
					<th scope="row">
						23 Maggio <br>
						ore 15:00 </th>
					<td>
						Ciphertext-policy ABE <br>
						(<a href="https://www.youtube.com/watch?v=y4TkZOUdEVI&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=16"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>CP-ABE based on pairings</li>
						</ul>
					</td>
					<td>Marco Pedicini <br> (ROMA3)</td>
				</tr>
				<tr>
					<th scope="row">
						24 Maggio <br>
						ore 15:00 </th>
					<td>
						Key-policy ABE <br>
						(<a href="https://www.youtube.com/watch?v=zb-e44Yjt6w" target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Key policy ABE</li>
							<li>Revocable storage</li>
						</ul>
					</td>
					<td>Riccardo Longo <br> (UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						25 Maggio <br>
						ore 15:00 </th>
					<td>
						FE I <br>
						(<a href="https://www.youtube.com/watch?v=7Bmuk-0plJA&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=17"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Introduction to Functional Encryption</li>
							<li>Security notions and mathematical assumptions</li>
						</ul>
					</td>
					<td>Irene Villa <br> (UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						26 Maggio <br>
						ore 15:00 </th>
					<td>
						FE II <br>
						(<a href="https://www.youtube.com/watch?v=po6TTrOxFxU&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=18"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Predicate Encryption (PE)</li>
							<li>PE with public index</li>
							<li>PE with private index</li>
						</ul>
					</td>
					<td>Carla Mascia <br> (UNITN)</td>
				</tr>
				<tr>
					<th scope="row">
						27 Maggio <br>
						ore 15:00 </th>
					<td>
						Secure multi-party <br> computation <br>
						(<a href="https://www.youtube.com/watch?v=wQLLJugFuzs&list=PLu4yxTVzRRMXi3o2q22Hcz5SJGn20FC34&index=19"
							target="_blank">Video</a>)
					</td>
					<td>
						<ul>
							<li>Security goals and proofs</li>
							<li>MPC based on Threshold Secret Sharing</li>
							<li>SPDZ</li>
						</ul>
					</td>
					<td>Mario Di Raimondo <br> (UNICT)</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<hr id="seminari">
<div class="row">
	<div class="col-md-12">
		<h3>PROGRAMMA DEI SEMINARI</h3>
		<table class="table table-striped">
			<thead>
				<tr>
					<th>Docente</th>
					<th>Titolo</th>
					<th>Data</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Daniele Taufer <br> (CISPA Helmholtz Center for Information Security)</td>
					<td>“Point groups of elliptic curves over structured rings and their
						cryptographic application”</td>
					<td>6 Maggio <br> 17:00 </td>
				</tr>
				<tr>
					<td>Antonio Tortora <br> (UNICAMPANIA)</td>
					<td>“An introduction to fully homomorphic encryption”</td>
					<td>11 Maggio <br> 16:00</td>
				</tr>
				<tr>
					<td>Alessio Caminata <br> (UNIGE)</td>
					<td>"Solving multivariate polynomial systems with Gröbner bases"</td>
					<td>12 Maggio <br> 10:00 </td>
				</tr>
				<tr>
					<td>Carmine Monetta <br> (UNISA)</td>
					<td>“Group-based cryptography: the choice of a good platform”</td>
					<td>16 Maggio <br> ore 16:30</td>
				</tr>
				<tr>
					<td>Francesca Mantese <br> (UNIVR)</td>
					<td>"Leavitt path algebras and interplay with cryptography and coding theory"</td>
					<td>18 Maggio <br> 11:00 </td>
				</tr>
				<tr>
					<td>Giulio Codogni <br> (ROMA 2) </td>
					<td>"A quick overview of isogeny graphs and isogeny based cryptography"</td>
					<td>25 Maggio <br> ore 11:00</td>
				</tr>
				<tr>
					<td>Giancarlo Rinaldo <br> (UNIME) </td>
					<td>"GeMSS: a post-quantum digital signature"</td>
					<td>30 Maggio <br> ore 15:00 </td>
				</tr>
				<tr>
					<td>Alessandro Barenghi <br> (POLIMI) </td>
					<td>“Secure realization of modern cryptographic primitives”</td>
					<td>31 Maggio <br> ore 15:00</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<hr>
<div>
	<h3>ESAME</h3>
	<p>
		La seconda sessione per l’esame di trends si tiene il 16 Dicembre alle
		ore 10. Il link zoom verrà comunicato in seguito.
	</p>
</div>
<hr>
<div>
	<h3>SLIDE</h3>
	<p>
		Sono disponibili le <a href="../../../assets/attivita/deCifrisTrends/SlidesTrendsinModernCrypto.zip">slide</a>
		delle presentazioni.
	</p>
</div>